import { ASSET_TYPES } from '@/services/AssetService/config';
import Env from '@/helpers/Env';

// **********************************************************************
// URLS
// **********************************************************************
export const fonts = {};

export const models = {};

export const images = {};

export const textures = {
  t_noise_green: `assets/textures-o/0_misc/noise-simplex-uastc.ktx2`,
  t_grid: `assets/textures-o/0_misc/grid.ktx2`,

  // t_glass: `assets/textures-o/shared/glass.ktx2`,
  t_jeremy: `assets/textures-o/shared/jeremy-512.ktx2`,
  t_haybale: `assets/textures-o/shared/haybale.ktx2`,

  t_ground: `assets/textures-o/shared/ground.ktx2`,
  t_fg: `assets/textures-o/shared/fg.ktx2`,
  t_trees: `assets/textures-o/shared/trees.ktx2`,
  t_bg: `assets/textures-o/shared/bg.ktx2`,

  t_cloud0: `assets/textures-o/clouds/cloud0.ktx2`,
  t_cloud1: `assets/textures-o/clouds/cloud1.ktx2`,
  t_cloud2: `assets/textures-o/clouds/cloud2.ktx2`,
  t_cloud3: `assets/textures-o/clouds/cloud3.ktx2`,
  t_cloud4: `assets/textures-o/clouds/cloud4.ktx2`,
};

export const sounds = {
  s_beerfarmer: `assets/sounds-o/beerfarmer.mp3`,
  s_music: `assets/sounds-o/beer_farmer_theme.mp3`,

  s_button: `assets/sounds-o/ui_button_press.mp3`,

  s_jeremy_jump0: `assets/sounds-o/jeremy_jump.mp3`,
  s_jeremy_jump1: `assets/sounds-o/huup.mp3`,
  s_jeremy_jump2: `assets/sounds-o/huh.mp3`,
  s_jeremy_jump3: `assets/sounds-o/huhhh.mp3`,
  s_jeremy_jump4: `assets/sounds-o/hup.mp3`,

  s_jeremy_run: `assets/sounds-o/jeremy_running.mp3`,
  s_jeremy_lose: `assets/sounds-o/jeremy_lose_riff.mp3`,

  s_on_screen_wasps: `assets/sounds-o/bees.mp3`,

  s_collect_barley: `assets/sounds-o/collect_barley.mp3`,
  s_collect_poo: `assets/sounds-o/collect_manure.mp3`,
  s_collect_truck: `assets/sounds-o/collect_barley_trailer.mp3`,

  s_collect_complete: `assets/sounds-o/thats_it.mp3`,

  s_collision_haybale: `assets/sounds-o/collision_haybale.mp3`,
  s_collision_cow: `assets/sounds-o/collision_cow.mp3`,
  s_collision_scarecrow: `assets/sounds-o/collision_scarecrow.mp3`,
  // s_collision_cloud: `assets/sounds-o/collision_raincloud.mp3`,
  s_collision_truck: `assets/sounds-o/collision_barley_truck.mp3`,

  s_level_end_0: `assets/sounds-o/riff_level_1.mp3`,
  s_level_end_1: `assets/sounds-o/riff_level_2.mp3`,
  s_level_end_2: `assets/sounds-o/level_3_riff.mp3`,

  s_empty_0: `assets/sounds-o/beer_glass_full_riff.mp3`,
  s_empty_1: `assets/sounds-o/manure_bag_empty.mp3`,
  s_empty_2: `assets/sounds-o/hopper_empty.mp3`,
};

const videos = {
  // v_landing: `assets/videos/GradedLanding.mp4`,
};

export const urls = {
  ...fonts,
  ...models,
  ...images,
  ...textures,
  ...sounds,
  ...videos,
};

// **********************************************************************
// MANIFEST
// **********************************************************************
export const manifest = {
  id: 'critical',
  items: [
    ...Object.entries(fonts).map(([id, url]) => ({ id, url })),
    ...Object.entries(models).map(([id, url]) => ({ id, url })),
    ...Object.entries(images).map(([id, url]) => ({ id, url })),
    ...Object.entries(textures).map(([id, url]) => ({ id, url })),
    ...Object.entries(sounds).map(([id, url]) => ({ id, url })),
    ...Object.entries(videos).map(([id, url]) => ({ id, url })),
  ],
};
